// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import { NewTier, type Tier, type TierWireFormat } from '../Tier/Tier';

export class ProductSummary {
  readonly id: string;
  readonly actualMargin: string | null;
  readonly alternateId: string;
  readonly category: Enums.ProductCategory;
  readonly costPerUnit: string;
  readonly name: string;
  readonly plantName: string;
  readonly pricePerUnit: string | null;
  readonly tiers: Tier[];
  readonly tierNames: string | null;
  readonly targetMarginPercentageOverride: string | null;
  readonly minimumMarginPercentageOverride: string | null;
  readonly targetMarginFlatAmountOverride: string | null;
  readonly minimumMarginFlatAmountOverride: string | null;
  readonly targetMargin: string | null;
  readonly minimumMargin: string | null;
  readonly marginsInheritedFrom: string;
  readonly suggestedPrice: string | null;
  readonly incompatibleMixQuantityUnits: string | null;
  readonly externalId: string | null;
  readonly isArchived: boolean;
  readonly marketId: string;
  readonly plantId: string;
  readonly divisionId: string | null;
  readonly plantIsArchived: boolean;
  readonly currencyCode: Enums.CurrencyCode;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.actualMargin = data.actualMargin === undefined ? null : data.actualMargin;
    this.alternateId = data.alternateId === undefined ? '' : data.alternateId;
    this.category = data.category === undefined ? Enums.ProductCategory.ReadyMix : data.category;
    this.costPerUnit = data.costPerUnit === undefined ? '' : data.costPerUnit;
    this.name = data.name === undefined ? '' : data.name;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.pricePerUnit = data.pricePerUnit === undefined ? null : data.pricePerUnit;
    this.tiers = (data.tiers ?? []).map((tiers: any) => NewTier(tiers));
    this.tierNames = data.tierNames === undefined ? null : data.tierNames;
    this.targetMarginPercentageOverride =
      data.targetMarginPercentageOverride === undefined
        ? null
        : data.targetMarginPercentageOverride;
    this.minimumMarginPercentageOverride =
      data.minimumMarginPercentageOverride === undefined
        ? null
        : data.minimumMarginPercentageOverride;
    this.targetMarginFlatAmountOverride =
      data.targetMarginFlatAmountOverride === undefined
        ? null
        : data.targetMarginFlatAmountOverride;
    this.minimumMarginFlatAmountOverride =
      data.minimumMarginFlatAmountOverride === undefined
        ? null
        : data.minimumMarginFlatAmountOverride;
    this.targetMargin = data.targetMargin === undefined ? null : data.targetMargin;
    this.minimumMargin = data.minimumMargin === undefined ? null : data.minimumMargin;
    this.marginsInheritedFrom =
      data.marginsInheritedFrom === undefined ? '' : data.marginsInheritedFrom;
    this.suggestedPrice = data.suggestedPrice === undefined ? null : data.suggestedPrice;
    this.incompatibleMixQuantityUnits =
      data.incompatibleMixQuantityUnits === undefined ? null : data.incompatibleMixQuantityUnits;
    this.externalId = data.externalId === undefined ? null : data.externalId;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
    this.currencyCode =
      data.currencyCode === undefined ? Enums.CurrencyCode.USD : data.currencyCode;
  }

  static zero(): ProductSummary {
    const zeroValues: ExcludeMethodsDeep<ProductSummary> = {
      id: NIL_UUID,
      actualMargin: null,
      alternateId: '',
      category: Enums.ProductCategory.ReadyMix,
      costPerUnit: '',
      name: '',
      plantName: '',
      pricePerUnit: null,
      tiers: [],
      tierNames: null,
      targetMarginPercentageOverride: null,
      minimumMarginPercentageOverride: null,
      targetMarginFlatAmountOverride: null,
      minimumMarginFlatAmountOverride: null,
      targetMargin: null,
      minimumMargin: null,
      marginsInheritedFrom: '',
      suggestedPrice: null,
      incompatibleMixQuantityUnits: null,
      externalId: null,
      isArchived: false,
      marketId: NIL_UUID,
      plantId: NIL_UUID,
      divisionId: null,
      plantIsArchived: false,
      currencyCode: Enums.CurrencyCode.USD,
    };
    return new ProductSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProductSummaryWireFormat = {
  id: string;
  actualMargin: string | null;
  alternateId: string;
  category: string;
  costPerUnit: string;
  name: string;
  plantName: string;
  pricePerUnit: string | null;
  tiers: TierWireFormat[];
  tierNames: string | null;
  targetMarginPercentageOverride: string | null;
  minimumMarginPercentageOverride: string | null;
  targetMarginFlatAmountOverride: string | null;
  minimumMarginFlatAmountOverride: string | null;
  targetMargin: string | null;
  minimumMargin: string | null;
  marginsInheritedFrom: string;
  suggestedPrice: string | null;
  incompatibleMixQuantityUnits: string | null;
  externalId: string | null;
  isArchived: boolean;
  marketId: string;
  plantId: string;
  divisionId: string | null;
  plantIsArchived: boolean;
  currencyCode: string;
};

type NewProductSummaryProps = PartialDeep<ProductSummary, { recurseIntoArrays: true }>;
export const NewProductSummary: (props: NewProductSummaryProps) => ProductSummary = (props) =>
  new ProductSummary(props);

type NewProductSummaryFromWireFormatProps = PartialDeep<
  ProductSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProductSummaryFromWireFormat: (
  props: NewProductSummaryFromWireFormatProps,
) => ProductSummary = (props) => new ProductSummary(props);
